/**
 * RegionTriger
 * 
 * @Author: Focci
 * @Date: 2023-07-24 22:01:18
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-24 22:01:18
 */

import PropTypes from 'prop-types'
import DropdownMenu from '@comp/DropdownMenu'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import SVGLocale from '@img/locale.svg'
import { filter } from 'lodash-es'
import { ButtonBase } from '@comp/material'

function RegionTrigerButton({
  label = ''
}) {
  return (
    <ButtonBase className="rounded-full">
      <div 
        className="
          flex items-center rounded-full border border-solid border-ce6 px-3 py-1.5
          transition-colors duration-500 hover:bg-cf0
        "
      >
        <SVGLocale width=".6rem" />
        <span className="ml-1">{label}</span>
        <KeyboardArrowDownIcon sx={{ fontSize: '.9rem' }} />
      </div>
    </ButtonBase>
  )
}

export default function RegionTriger({
  ...dropDownProps
}) {
  const currentOption = filter(dropDownProps.options, (f) => f.value === dropDownProps.value)
  return (
    <DropdownMenu
      trigger={<RegionTrigerButton label={currentOption[0]?.label} />}
      {...dropDownProps}
    />
  )
}

RegionTriger.propTypes = {
  data: PropTypes.array,
}
